import { Theme } from '@mui/material';
import { globalClasses } from 'core/common/constants/global-classes';

type ModalComponentType = {
  styleOverrides: {
    root: () => Record<string, unknown>;
  };
};

export const getModalOptions = ({ palette }: Theme): { modalComponent: ModalComponentType } => {
  const modalComponent = {
    styleOverrides: {
      root: () => {
        return {
          backgroundColor: palette.modal.backdrop,

          [globalClasses.modalContent]: {
            width: '100%',
            maxWidth: '500px',
            backgroundColor: palette.modal.body,
            borderRadius: '16px',
            padding: '16px ',
            margin: '13px',
            boxShadow: 'none',
          },
        };
      },
    },
  };

  return { modalComponent };
};
